import React, { type JSX } from 'react';
import { Tooltip } from 'react-tooltip';
import { Annotation, ChatMessage } from '@/actions/dtos/chat';

interface CustomParagraphProps {
  children?: React.ReactNode;
  index: number;
  chatMessages: ChatMessage[];
  as?: keyof JSX.IntrinsicElements;
}

const CustomParagraph: React.FC<CustomParagraphProps> = ({ children, index, chatMessages, as = 'p' }) => {
  const Tag = as;

  return (
    <>
      <Tag>
        {React.Children.map(children, (child) =>
          typeof child === 'string'
            ? child.split(/(\{\{\{\d+\}\}\})/).map((part, i) => {
                const match = part.match(/\{\{\{(\d+)\}\}\}/);
                if (match) {
                  const annotationMarker = match[0];
                  const annotation = chatMessages[index]?.annotations?.find(
                    (a: Annotation) => a.marker === annotationMarker,
                  );

                  if (annotation) {
                    return (
                      <span
                        key={i}
                        className="inline-block"
                        data-tooltip-id="annotation-tooltip"
                        data-tooltip-content={annotation.document.name}
                      >
                        [*]
                      </span>
                    );
                  }
                }
                return <span key={i}>{part}</span>;
              })
            : child,
        )}
      </Tag>
      <Tooltip id="annotation-tooltip" />
    </>
  );
};

export default CustomParagraph;
